<template>
  <div style="margin-top:30PX; height: 100%;" :class="{'mobileSecurity': mobile == 1}">
    <div class="main">
      <div class="main-title">
        <h2>{{$t('security.resetSecurity')}}</h2>
      </div>
    </div>
    <div class="isSureSecurity" v-if="isSureSecurity == 0">
        <div class="card-div">
        <div class="securityH1">
            <h1>{{$t('security.applyInformation')}}</h1>
        </div>
        </div>
        <div class="securityFrom">
        <el-form label-position="right" :label-width="width" :model="formSecurity" :rules="rules" ref="ruleForm">
            <el-form-item :label="$t('help.businessType')" prop="businessType">
            <el-select v-model="formSecurity.businessType">
                <el-option :label="$t('help.gameUsers')" value="Game-users"></el-option>
                <!-- <el-option label="商城用户" value="shangcheng"></el-option>
                    <el-option label="云服务用户" value="yunfuwu"></el-option>
                    <el-option label="其他用户" value="qita"></el-option> -->
            </el-select>
            </el-form-item>
            <el-form-item :label="$t('help.appealAccount')" prop="appealAccount" :error="errorAppeal">
            <el-input v-model="formSecurity.appealAccount" :placeholder="$t('help.enterGrievanceAccount')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.ContactEmail')" prop="email" :error="EmailerrorAppeal">
            <el-input v-model="formSecurity.email" :placeholder="$t('help.enterEmail1')" ></el-input>
            </el-form-item>
            <el-form-item label="UserID:" prop="userId" :error="UserIDerrorAppeal">
            <el-input v-model="formSecurity.userId" :placeholder="$t('security.UserId')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.code')" prop="code" :error="CodeerrorAppeal" :class="{'mobildCode': mobile == 1}">
              <el-input v-model="formSecurity.code" :placeholder="$t('appeal.pEnterGraphicCode1')" style="width: 52%;vertical-align:middle;"></el-input>
              <img :src="emailimgUrl" @click="newImgHandler" class="imgCodeE">
            </el-form-item>
            <el-form-item :label="$t('security.linkSecurity')" prop="generateResetLink" :class="{'enUSlabel': this.$i18n.locale == 'en_US' || mobile == 1}"  :rules="{
              required: true, message: this.$t('security.optionNempty'), trigger: 'change'
            }">
            <el-radio-group v-model="formSecurity.generateResetLink">
                <el-radio :label="1">{{$t('freezing.yes')}}</el-radio>
                <el-radio :label="0">{{$t('freezing.no')}}</el-radio>
            </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('security.linkAccount')" prop="generateStstusLink" :class="{'enUSlabel': this.$i18n.locale == 'en_US' || mobile == 1}" :rules="{
              required: true, message: this.$t('security.optionNempty'), trigger: 'change'
            }">
            <el-radio-group v-model="formSecurity.generateStstusLink">
                 <el-radio :label="1">{{$t('freezing.yes')}}</el-radio>
                <el-radio :label="0">{{$t('freezing.no')}}</el-radio>
            </el-radio-group>
            </el-form-item>
        </el-form>
        </div>
        <div class="btn-div btnSure">
        <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{$t('security.submit')}}</el-button>
        </div>
    </div>
    <div v-if="isSureSecurity == 1">
        <div class="dialogLink">
            <h3 class="DialoglinkExpired">{{$t('security.applyAccepted')}} </h3>
            <p>{{$t('security.userEmail')}}</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="errOk() ">{{$t('help.sure')}}</el-button>
            </span>
        </div>
    </div>
    <div v-if="isSureSecurity == 2">
        <div class="dialogLink" style="margin-top: 15%;">
            <h3 class="DialoglinkExpired">{{$t('security.access')}} </h3>
            
        </div>
    </div>
  </div>
</template>
<script>
  import {
    isEmail,
    isPsw,
    isMobile
  } from "../../utils/validate";
  import {
    setCapture
  } from "../../utils";
  import apiUrl from '@/utils/api' //api 接口

  export default {
    props: ['mobile'],
    data() {
      return {
        width: '200Px',
        isSureSecurity: '0',
        errorAppeal:'',
        UserIDerrorAppeal: '',
        CodeerrorAppeal: '',
        EmailerrorAppeal:'',
        emailimgUrl: '',
        time: new Date().getTime(),
        formSecurity: {
          businessType: 'Game-users',
          appealAccount: '',
          email: '',
          userId: '',
          code: '',
          tag: '',
          generateResetLink: null,
          generateStstusLink: null, 
        },
        rules:{
            appealAccount: [
                { required: true, 
                validator: (rule, value, callback) => {
                if(value == ''){
                  callback(new Error(this.$t('help.enterGrievanceAccount')));
                }else {
                  callback();
                }
                },
                trigger: 'blur' },
            ],
            email: [{
                required: true,
                validator: (rule, value, callback) => {
                var value = value.replace(/\s*/g, "");
                if(value == ''){
                  callback(new Error(this.$t('help.enterEmail1')));
                }else if (!isEmail(value) && value != '') {
                    callback(new Error(this.$t('help.errEmail')));
                } else {
                    callback();
                }
                },
                trigger: "blur"
            }],
            code: [
                { required: true,
                validator: (rule, value, callback) => {
                if(value == ''){
                  callback(new Error(this.$t('appeal.pEnterGraphicCode1')));
                }else {
                  callback();
                }
                },
                trigger: 'blur'
                }
            ],
            userId: [
                { required: true, 
                validator: (rule, value, callback) => {
                if(value == ''){
                  callback(new Error(this.$t('security.UserId')));
                }else {
                  callback();
                }
                },
                trigger: 'blur' },
            ]
        }
      }
    },
    mounted(){
      this.limit()
    },
     methods: {
      errOk() {
        location.href = this.$baseUrl + "home-page"
      },
      newImgHandler() {
        this.time = new Date().getTime();
        this.emailimgUrl = setCapture(this.time);
        this.formSecurity.tag = this.time;
      },
      limit() {
         fetch('/appeal/checkPermission', {
                          method: "POST",
                          body: '',
                          headers: {
                            'Content-Type': 'application/json'
                          },
                        }).then(response => response.json())
                        .then(data => {
                         if (data.code == "200") {
                          this.newImgHandler();
                          this.isSureSecurity = 0;
                          }else{
                            this.isSureSecurity = 2;
                          }
                          
                        }).catch((err) => {
                          console.log(err)
                        })
      },
      submitForm(formName) {
        this.errorAppeal = '';
        this.UserIDerrorAppeal = '';
        this.CodeerrorAppeal = '';
        this.EmailerrorAppeal = '';
        this.$refs[formName].validate((valid) => {
          if (valid) {
            fetch('/appeal/getResetLink', {
                          method: "POST",
                          body: JSON.stringify(this.formSecurity),
                          headers: {
                            'Content-Type': 'application/json'
                          },
                        }).then(response => response.json())
                        .then(data => {
                          if(data.code !== '200'){
                              this.newImgHandler();
                          }
                         if (data.code == "200") {
                            this.errorAppeal = '';
                            this.UserIDerrorAppeal = '';
                            this.CodeerrorAppeal = '';
                            this.EmailerrorAppeal = '';
                            this.isSureSecurity = 1;

                          } else if (data.code == "2001") {
                            this.errorAppeal = this.$t('help.againFill');

                          }  else if (data.code == "2006") {
                            this.errorAppeal = this.$t('appeal.accountNotExist');

                          } else if (data.code == "2003") {
                            this.errorAppeal = this.$t('help.incorrectEP');
  
                          }else if (data.code == "2008") {
                            this.UserIDerrorAppeal = this.$t('security.userIDInvalid');
                          }else if (data.code == '2002'){
                            this.EmailerrorAppeal = this.$t('help.emailNoAgain')
                          }else if (data.code == '2010'){
                            this.errorAppeal = this.$t('security.notSubmit')
                          }else if (data.code == '2011'){
                            this.EmailerrorAppeal = this.$t('security.notMatch')
                          }else if (data.code == '1003'){
                            this.CodeerrorAppeal = this.$t('appeal.verificationCodeError1')
                          }
                          
                        }).catch((err) => {
                          console.log(err)
                        })

          } else {
            return false;
          }
        });
      },
     },
    watch:{
       mobile(newName, oldName){
           if(newName == 1) this.width = '130PX';
           else this.width = '200PX';
           this.$forceUpdate();
       }
    }
  }
</script>
<style>
 .el-form-item__error {
    font-size: 12px !important;
    line-height: 12PX !important;
    padding-top: 0px !important;
  }
  .el-steps--horizontal,
  .el-step__title {
    font-size: 16PX !important;
  }

  .securityFrom .el-form-item {
    margin-bottom: 25PX!important;
  }
  .mobileSecurity .el-form-item{
      margin-left: -15PX!important;
  }
  .el-checkbox {
    font-size: 14PX !important;
  }

  .el-button {
    border-radius: 4px !important;
  }
  .securityFrom .el-select{
    width: 100%;
  }

  .el-form-item__content {
    line-height: 40PX !important;
  }
  .enUSlabel .el-form-item__label{
    line-height: 20PX!important;
    white-space: break-spaces!important;
  }
  .mobildCode .imgCodeE,.mobildCode .el-input{
    width: 100%!important;
  }
  .el-input__inner {
    height: 40PX !important;
    border: 1px solid #DCDFE6 !important;
    border-radius: 4PX !important;
    padding: 0 10px !important;
    line-height: 40px;
    font-size: 14PX;
  }
  .mobileSecurity .el-input__inner{
    font-size: 10PX!important;
  }
.el-radio__inner{
    width: 18PX!important;
    height: 18PX!important;
    border:1PX solid #DCDFE6!important;
}
.el-radio{
    margin-right: 20PX!important;
}
.el-radio__label{
    padding-left: 10PX!important;
}
.el-radio__label,.el-radio, .el-radio--medium.is-bordered .el-radio__label{
    font-size: 14PX!important;
}
  .el-input__icon {
    height: 100% !important;
    width: 25px !important;
    line-height: 40px !important;
  }

  .el-form-item__label {
    line-height: 40px !important;
    padding: 0 12px 0 0 !important;
    font-size: 14PX !important;
    /* white-space: nowrap; */
  }

  .el-form-item__content,
  .el-input {
    font-size: 14PX !important;
  }

  .el-select .el-input .el-select__caret {
    font-size: 14PX !important;
  }

  .back,
  .el-button {
    padding: 11px 20px !important;
    font-size: 14px !important;
  }
  .securityFrom .el-form-item__label:before{
      display: none!important;
  }
</style>

<style scoped lang="scss">
  .dialogLink {
    margin-top: 150PX;
    text-align: center;

    .DialoglinkExpired {
      display: block;
      font-size: 18PX;
      margin-bottom: 10PX;
      padding: 0 10PX;
    }
  }
  .imgCodeE{
    height: 38PX;
    cursor: pointer; 
    width: 45%;
    border:1px solid #ccc;
    vertical-align:middle;
    border-radius:4px;
  }
  .user-div {
    margin-top: 30PX;

    span {
      line-height: 25PX;
      font-size: 14PX;
    }

    p {
      font-size: 13PX;
      display: inline-block;
    }

    .notes {
      color: #666 !important;
      margin-top: 12PX;
      font-size: 12PX;
    }
  }

  .btn-div {
    margin-top: 40PX;
    // text-align: center;
    margin-left: 400PX;
    margin-bottom: 60PX;
    .btn {
      width: 190PX;
    }

    .btn-no {
      background-color: #B8B8B8;
      border-color: #B8B8B8;
    }
  }

  .main-title {
    //   padding: 0 14%;
    border-bottom: 1PX solid #ddd;
    background-color: #ffffff;

    position: relative;
    overflow: hidden;

    h2 {
      font-size: 18PX;
      font-weight: bold;
      color: #666 !important;
      padding: 25PX 14% 45PX 14%;
    }

    p {
      font-size: 16PX;
      color: #666 !important;
      margin-top: 12PX;
    }
  }

  .card-div {
    margin-top: 50PX;
    padding: 0 14%;
    overflow: hidden;
    margin-bottom: 20PX;

    h1 {
      font-size: 16PX;
      font-weight: normal;
      margin-left:130PX;
    }

    p {
      color: #999999;
    }
  }

  .toptip {
    font-size: 18PX;
  }

  .mobileChange {
    .main-title {
      padding: 0 25PX;

      h2 {
        padding: 25PX 0 45PX 0;
      }
    }

    .card-div {
      padding: 0 25PX !important;
    }

    .btn-div {
      margin: 20PX 30PX;
      padding: 20PX auto;

      .btn {
        width: 115PX !important;
      }
    }

    .btnSure {
      text-align: right;
    }
  }

  .securityFrom {
    padding: 0 14%;
    width: 500PX;
  }
  .mobileSecurity .securityFrom{
      padding: 0 20PX;
      width: 330PX;
  }
  .mobileSecurity{
    .isSureSecurity{
      padding-bottom: 30PX;
    }
    .securityH1{
      h1{
        margin-left: 10Px!important;
      }
    }
    .btn-div{
      margin-left: 132PX!important;
    }
  }
.dialogLink{
    margin-top: 150PX;
    text-align: center;
    p{
        font-size: 14PX;
        margin:20PX 0;
    }
    .DialoglinkExpired{
      display: block;
      font-size: 18PX;
      margin-bottom: 10PX;
      padding:0 10PX;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/changeActiveState/SecurityInformation.vue